export const ON = 'ON';
export const OFF = 'OFF';
